<template>
  <div class="view">
    <div class="view__wrapper">
      <Viewer
        :amount="amountImages"
        :hotspots="hotspots"
        :location="type"
        @hotspot-click="showModal"
        @newHotspot="showNewHotspots($event)"
        :passedIndex="currentFrameIndex"
        :key="type + Math.random(0, 2) + fetched"
      />
    </div>
    <div class="view__modal" v-show="showInfo">
      <div class="view__modal__header">
        <h2>{{ title }}</h2>
        <div class="view__modal__header--close" @click="showInfo = false"></div>
      </div>
      <div class="view__modal__content">
        <img
          class="view__modal__content--image"
          ref="infoImg"
          :src="image"
          v-if="image"
        />
        <div v-html="text"></div>
      </div>
    </div>
    <div class="newlocations" v-if="newHotspots.length !== 0">
      <pre>{{ newHotspots }}</pre>
    </div>
  </div>
</template>

<script>
import Viewer from "@/components/Viewer.vue";
export default {
  name: "ThreeSixty",
  components: {
    Viewer,
  },
  props: {
    hotspots: {
      type: Array,
      require: true,
      default: () => [],
    },
    type: {
      type: String,
      require: true,
      default: "",
    },
    fetched: {
      type: Boolean,
      require: true,
      default: false,
    },
  },
  watch: {
    type: {
      handler() {
        this.showInfo = false;
      },
      deep: true,
    },
  },
  data() {
    return {
      showInfo: false,
      amountImages: 24,
      currentFrameIndex: 19,
      text: "",
      title: "",
      image: "",
      currentImages: [],
      loaded: false,
      imagesToPreload: {},
      preloadedImages: {},
      imagesPreloaded: false,
      newHotspots: [],
      tooltip: "",
    };
  },
  methods: {
    showNewHotspots(e) {
      this.newHotspots.push(e);
    },
    showModal(hotspot) {
      let title = this.hotspots[hotspot.id].title;
      if (title !== undefined) {
        this.showInfo = true;
        this.currentFrameIndex = hotspot.frameIndex;
        this.text = this.hotspots[hotspot.id].text;
        this.image = this.hotspots[hotspot.id].image;
        this.title = title;
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/imports/media.scss";
.view {
  position: relative;
  &__wrapper {
    margin: 0 auto;
    max-width: 600px;
    &--spinner {
      background-image: url("../assets/images/placeholder_blur.png");
      color: red;
      width: 100%;
      height: 100%;
    }
  }
  &__modal {
    position: absolute;
    overflow: scroll;
    top: 0px;
    left: -1px;
    bottom: -25px;
    z-index: 30;
    right: -1px;
    background-color: rgba(255, 255, 255, 0.904);
    border: 1px solid #1a9cab;
    backdrop-filter: blur(5px);
    ul {
      list-style-position: inside;
    }
    &__header {
      position: sticky;
      z-index: 1;
      top: 0;
      left: 0;
      right: 0;
      display: block;
      color: #fff;
      padding: 0.4em 1em;
      margin: 0;
      background-color: #1a9cab;
      display: flex;
      justify-content: space-between;
      align-items: center;
      h2 {
        margin: 0.3em 0;
        font-size: 1.2em;
        text-align: left;
      }
      &--close {
        z-index: 2;
        width: 30px;
        height: 30px;
        cursor: pointer;
        position: relative;
        &::after,
        &::before {
          content: "";
          display: block;
          width: 4px;
          margin-top: 2.5px;
          margin-left: -2px;
          height: 25px;
          background-color: #fff;
          position: absolute;
          top: 0;
          left: 50%;
          border-radius: 5px;
          transform: rotate(45deg);
        }
        &:hover {
          background-color: #14535bad;
          border-radius: 50%;
        }
        &::after {
          transform: rotate(-45deg);
        }
      }
    }
    &__content {
      box-sizing: border-box;
      padding: 1.5em;
      width: 100%;
      height: 90%;
      line-height: 1.6;
      font-size: 1.1em;
      color: #212529;
      p {
        padding-bottom: 1em;
      }
      @include phone {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      &--image {
        float: left;
        display: inline-block;
        width: 40%;
        // height: 50%;
        margin-right: 1.5em;
        // margin-bottom: 1.5em;
        background-size: auto 100%;
        background-position: center top;
        background-repeat: no-repeat;
        @include phone {
          margin-right: 0;
          width: 100%;
          min-height: 200px;
        }
      }
    }
  }
  .newlocations {
    position: absolute;
    top: 120%;
    background-color: rgb(238, 238, 171);
    padding: 1em;
  }
}
</style>
